var map = {
	"./air-nga-en/assets/document-icon.png": 32011,
	"./ais-tai-en/assets/document-icon.png": 39194,
	"./ais-tai-tha/assets/document-icon.png": 74838,
	"./demo-arabic/assets/document-icon.png": 34670,
	"./demo-et-en/assets/document-icon.png": 38719,
	"./demo-romanian/assets/document-icon.png": 12917,
	"./demo-um-en/assets/document-icon.png": 56878,
	"./dtac-tai-en/assets/document-icon.png": 30197,
	"./dtac-tai-tha/assets/document-icon.png": 55939,
	"./ethiotel-et-amh/assets/document-icon.png": 70609,
	"./ethiotel-et-en/assets/document-icon.png": 21364,
	"./mtn-cg-fr/assets/document-icon.png": 68121,
	"./mtn-ci-fr/assets/document-icon.png": 62003,
	"./mtn-cmr-fr/assets/document-icon.png": 5831,
	"./mtn-gha-en/assets/document-icon.png": 59036,
	"./mtn-nga-en/assets/document-icon.png": 88816,
	"./mtn-zam-en/assets/document-icon.png": 93198,
	"./saf-ke-en/assets/document-icon.png": 30615,
	"./saudi-uae-en/assets/document-icon.png": 96702,
	"./tlk-za-en/assets/document-icon.png": 76395,
	"./vc-za-en/assets/document-icon.png": 91271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75761;